import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPeopleGroup } from '@fortawesome/free-solid-svg-icons';
import marek_ogryzek from '../../assets/komitet-organizacyjny/Marek-Ogryzek.webp';
import blank_person from '../../assets/komitet-organizacyjny/blank-person.webp';

import malgorzata_renigier_bilozor from '../../assets/komitet-organizacyjny/Malgorzata-Renigier-Bilozor.webp';
import andrzej_bilozor from '../../assets/komitet-organizacyjny/Andrzej-Bilozor.webp';
import iwona_cieslak from '../../assets/komitet-organizacyjny/Iwona-Cieslak.webp';
import wioleta_blaszczak from '../../assets/komitet-organizacyjny/Wioleta-Blaszczak-Bak.webp';
import marta_nalej from '../../assets/komitet-organizacyjny/Marta-Nalej.webp';
import mateusz_ciski from '../../assets/komitet-organizacyjny/Mateusz-Ciski.webp';
import bartlomiej_ezlakowski from '../../assets/komitet-organizacyjny/Bartlomiej-Ezlakowski.webp';

import BSZ2023 from '../../assets/komitet-naukowy/BSZ2023.webp';
import EB2023 from '../../assets/komitet-naukowy/EB2023.webp';
import AJ2024 from '../../assets/komitet-naukowy/AJ2024.webp';
import AI2023 from '../../assets/komitet-naukowy/AI2023.webp';
import IJ2023 from '../../assets/komitet-naukowy/IJ2023.webp';
import LG2023 from '../../assets/komitet-naukowy/LG2023.webp';
import MR2023 from '../../assets/komitet-naukowy/MR2023.webp';
import PW2023 from '../../assets/komitet-naukowy/PW2023.webp';
import PWE2023 from '../../assets/komitet-naukowy/PWE2023.webp';
import KK2023 from '../../assets/komitet-naukowy/KK2023.webp';
import MF2023 from '../../assets/komitet-naukowy/MF2023.webp';
import DG2023 from '../../assets/komitet-naukowy/DG2023.webp';
import ZZ2023 from '../../assets/komitet-naukowy/ZZ2023.webp';

import MK2026 from '../../assets/komitet-naukowy/MK2026.webp';
import EL2026 from '../../assets/komitet-naukowy/EL2026.webp';
import AS2026 from '../../assets/komitet-naukowy/AS2026.webp';
import DW2026 from '../../assets/komitet-naukowy/DW2026.webp';
import JU2026 from '../../assets/komitet-naukowy/JU2026.webp';

import './committees.css';

const Committees = () => {
  return (
    <div className="giswnauce__committees">
        <div className="giswnauce__committees-container">
            <div className="committees-container_header">
                <p><FontAwesomeIcon icon={faPeopleGroup} /></p><h1>Komitety</h1>
            </div>
            <div className="committees-container_subheader">
                <span className="anchor-scientific-committee" id="giswnauce_scientific-committee"></span>
                <h2>Komitet Naukowy</h2>
            </div>
            <div className="committees-container_description">
                <ul>
                    <li>
                        <a className="committee-more" href="https://www.wig.wat.edu.pl/index.php/pracownicy/wizytowki/geodezja-i-kartografia/316-prof-dr-hab-inz-elzbieta-bielecka" target="_blank" rel="noreferrer"><img src={ EB2023 } alt="Elżbieta Bielecka" /></a>
                        <p><a href="https://www.wig.wat.edu.pl/index.php/pracownicy/wizytowki/geodezja-i-kartografia/316-prof-dr-hab-inz-elzbieta-bielecka" target="_blank" rel="noreferrer"><b>Prof. dr hab. inż. Elżbieta Bielecka</b></a><br />
                        Wydział Inżynierii Lądowej i&nbsp;Geodezji<br />
                        Wojskowa Akademia Techniczna, Warszawa</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://mostwiedzy.pl/pl/mariusz-figurski,1137185-1" target="_blank" rel="noreferrer"><img src={ MF2023 } alt="Mariusz Figurski" /></a>
                        <p><a href="https://mostwiedzy.pl/pl/mariusz-figurski,1137185-1" target="_blank" rel="noreferrer"><b>Prof. dr hab. inż. Mariusz Figurski</b></a><br />
                        Instytut Meteorologii i Gospodarki Wodnej<br />
                        Państwowy Instytut Badawczy<br />
                        Wydział Inżynierii Lądowej i&nbsp;Środowiska<br />
                        Politechnika Gdańska, Gdańsk</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://www.uni.lodz.pl/pracownicy/iwona-jazdzewska" target="_blank" rel="noreferrer"><img src={ IJ2023 } alt="Iwona Jażdżewska" /></a>
                        <p><a href="https://www.uni.lodz.pl/pracownicy/iwona-jazdzewska" target="_blank" rel="noreferrer"><b>Prof. dr hab. Iwona Jażdżewska</b></a><br />
                        Wydział Nauk Geograficznych<br />
                        Uniwersytet Łódzki, Łódź</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://usosweb.uw.edu.pl/kontroler.php?_action=katalog2/osoby/pokazOsobe&os_id=50331" target="_blank" rel="noreferrer"><img src={ PWE2023 } alt="Piotr Werner" /></a>
                        <p><a href="https://usosweb.uw.edu.pl/kontroler.php?_action=katalog2/osoby/pokazOsobe&os_id=50331" target="_blank" rel="noreferrer"><b>Prof. dr hab. Piotr Werner</b></a><br />
                        Wydział Geografii i&nbsp;Studiów Regionalnych<br />
                        Uniwersytet Warszawski, Warszawa</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://amu.edu.pl/dla-mediow/baza-ekspertow/klimat-i-ekologia/prof.-zbigniew-zwolinski" target="_blank" rel="noreferrer"><img src={ ZZ2023 } alt="Zbigniew Zwoliński" /></a>
                        <p><a href="https://amu.edu.pl/dla-mediow/baza-ekspertow/klimat-i-ekologia/prof.-zbigniew-zwolinski" target="_blank" rel="noreferrer"><b>Prof. dr hab. Zbigniew Zwoliński</b></a><br />
                        Zakład Geoinformacji<br />
                        Uniwersytet im. Adama Mickiewicza, Poznań</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://bazawiedzy.uwm.edu.pl/info/author/UWM0bf7d6a2650c413c9232dc72a0528491?ps=20&tab=main&lang=pl&title=Person%2Bprofile%2B%25E2%2580%2593%2BArtur%2BJanowski%2B%25E2%2580%2593%2BUniversity%2Bof%2BWarmia%2Band%2BMazury&pn=1&cid=526266" target="_blank" rel="noreferrer"><img src={ AJ2024 } alt="Artur Janowski" /></a>
                        <p><a href="https://bazawiedzy.uwm.edu.pl/info/author/UWM0bf7d6a2650c413c9232dc72a0528491?ps=20&tab=main&lang=pl&title=Person%2Bprofile%2B%25E2%2580%2593%2BArtur%2BJanowski%2B%25E2%2580%2593%2BUniversity%2Bof%2BWarmia%2Band%2BMazury&pn=1&cid=526266" target="_blank" rel="noreferrer"><b>Dr hab. inż. Artur Janowski, prof. UWM</b></a><br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski, Olsztyn</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://omega.umk.pl/info/author/UMK0098badc387da651733498ca8683ebe27c28ab63250e2581cbc333458fd5b447/" target="_blank" rel="noreferrer"><img src={ MK2026 } alt="Mieczysław Kunz" /></a>
                        <p><a href="https://omega.umk.pl/info/author/UMK0098badc387da651733498ca8683ebe27c28ab63250e2581cbc333458fd5b447/" target="_blank" rel="noreferrer"><b>Dr hab. Mieczysław Kunz, prof. UMK</b></a><br />
                        Wydział Nauk o Ziemi i&nbsp;Gospodarki Przestrzennej<br />
                        Uniwersytet Mikołaja Kopernika w&nbsp;Toruniu</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://uwm.edu.pl/kgse/sklad-osobowy/adam-senetra" target="_blank" rel="noreferrer"><img src={ AS2026 } alt="Adam Senetra" /></a>
                        <p><a href="https://uwm.edu.pl/kgse/sklad-osobowy/adam-senetra" target="_blank" rel="noreferrer"><b>Dr hab. Adam Senetra, prof. UWM</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://repozytorium.bg.ug.edu.pl/info/author/UOG2db44d31d146432181eedc8fb86e896c" target="_blank" rel="noreferrer"><img src={ JU2026 } alt="Jacek Urbański" /></a>
                        <p><a href="https://repozytorium.bg.ug.edu.pl/info/author/UOG2db44d31d146432181eedc8fb86e896c" target="_blank" rel="noreferrer"><b>dr hab. Jacek Urbański, prof. UG</b></a><br />
                         Uniwersytet Gdański</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://www.umcs.pl/pl/addres-book-employee,757,pl.html" target="_blank" rel="noreferrer"><img src={ LG2023 } alt="Leszek Gawrysiak" /></a>
                        <p><a href="https://www.umcs.pl/pl/addres-book-employee,757,pl.html" target="_blank" rel="noreferrer"><b>Dr hab. Leszek Gawrysiak</b></a><br />
                        Wydział Nauk o&nbsp;Ziemii i&nbsp;Gospodarki Przestrzennej<br />
                        Uniwersytet Marii Curie-Skłodowskiej, Lublin</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://repo.pw.edu.pl/info/author/WUT54633/Dariusz%2BGotlib?tab=&r=author&lang=pl" target="_blank" rel="noreferrer"><img src={ DG2023 } alt="Dariusz Gotlib" /></a>
                        <p><a href="https://repo.pw.edu.pl/info/author/WUT54633/Dariusz%2BGotlib?tab=&r=author&lang=pl" target="_blank" rel="noreferrer"><b>Dr hab. inż. Dariusz Gotlib</b></a><br />
                        Wydział Geodezji i&nbsp;Kartografii<br />
                        Politechnika Warszawska, Warszawa</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://skos.agh.edu.pl/osoba/krystian-koziol-6626.html" target="_blank" rel="noreferrer"><img src={ KK2023 } alt="Krystian Kozioł" /></a>
                        <p><a href="https://skos.agh.edu.pl/osoba/krystian-koziol-6626.html" target="_blank" rel="noreferrer"><b>Dr hab. inż. Krystian Kozioł</b></a><br />
                        Wydział Geodezji Górniczej i&nbsp;Inżynierii Środowiska<br />
                        Akademia Górniczo-Hutnicza im.&nbsp;Stanisława Staszica, Kraków</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://omegatest.uwm.edu.pl/info/author/UWM369dfb7e8a8849718787b85a3347fbc8/" target="_blank" rel="noreferrer"><img src={ EL2026 } alt="Elżbieta Lewandowicz" /></a>
                        <p><a href="https://omegatest.uwm.edu.pl/info/author/UWM369dfb7e8a8849718787b85a3347fbc8/" target="_blank" rel="noreferrer"><b>Dr hab. inż. Elżbieta Lewandowicz</b></a><br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski, Olsztyn</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://rzeszewski.org/" target="_blank" rel="noreferrer"><img src={ MR2023 } alt="Michał Rzeszewski" /></a>
                        <p><a href="https://rzeszewski.org/" target="_blank" rel="noreferrer"><b>Dr hab. Michał Rzeszewski</b></a><br />
                        Wydział Geografii Społeczno-Ekonomicznej i&nbsp;Gospodarki Przestrzennej<br />
                        Uniwersytet im. Adama Mickiewicza, Poznań</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://wiki.kul.pl/lhdb/Bogumi%c5%82_Szady" target="_blank" rel="noreferrer"><img src={ BSZ2023 } alt="Bogumił Szady" /></a>
                        <p><a href="https://wiki.kul.pl/lhdb/Bogumi%c5%82_Szady" target="_blank" rel="noreferrer"><b>Dr hab. Bogumił Szady</b></a><br />
                        Ośrodek Badań nad Geografią Historyczną Kościoła w&nbsp;Polsce<br />
                        Katolicki Uniwersytet Lubelski, Lublin<br />
                        Instytut Historii im. Tadeusza Manteuffla<br />
                        Polska Akademia Nauk, Warszawa</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://urk.edu.pl/pracownicy.html/2881" target="_blank" rel="noreferrer"><img src={ PW2023 } alt="Piotr Wężyk" /></a>
                        <p><a href="https://urk.edu.pl/pracownicy.html/2881" target="_blank" rel="noreferrer"><b>Dr hab. inż. Piotr Wężyk</b></a><br />
                        Wydział Leśny<br />
                        Uniwersytet Rolniczy, Kraków</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://mostwiedzy.pl/pl/adam-inglot,1017456-1?" target="_blank" rel="noreferrer"><img src={ AI2023 } alt="Adam Inglot" /></a>
                        <p><a href="https://mostwiedzy.pl/pl/adam-inglot,1017456-1?" target="_blank" rel="noreferrer"><b>Dr inż. Adam Inglot</b></a><br />
                        Wydział Inżynierii Lądowej i&nbsp;Środowiska<br />
                        Politechnika Gdańska, Gdańsk</p>
                    </li>
                    <li>
                        <a className="committee-more" href="https://pg.edu.pl/p/dominika-wroblewska-17648" target="_blank" rel="noreferrer"><img src={ DW2026 } alt="Dominika Wróblewska" /></a>
                        <p><a href="https://pg.edu.pl/p/dominika-wroblewska-17648" target="_blank" rel="noreferrer"><b>Dr inż. Dominika Wróblewska</b></a><br />
                        Katedra Geodezji<br />
                        Politechnika Gdańska</p>
                    </li>
                </ul>
            </div>
            <div className="committees-container_subheader">
                <span className="anchor-organizing-committee" id="giswnauce_organizing-committee"></span>
                <h2>Komitet Organizacyjny</h2>
            </div>
            <div className="committees-container_description">
                <h3>Przewodniczący</h3>
                <ul>
                    <li>
                        <a className="committee-more" href="https://uwm.edu.pl/kgse/sklad-osobowy/marek-ogryzek" target="_blank" rel="noreferrer"><img src={ marek_ogryzek } alt="Marek Ogryzek" /></a>
                        <p><a href="https://uwm.edu.pl/kgse/sklad-osobowy/marek-ogryzek" target="_blank" rel="noreferrer"><b>Dr hab. inż. Marek Ogryzek, prof UWM</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>
                </ul>
                <h3>Członkowie</h3>
                <ul>
                    <li>
                        <a className="committee-more" href="https://uwm.edu.pl/igpig/kapirn/malgorzata-renigier-bilozor" target="_blank" rel="noreferrer"><img src={ malgorzata_renigier_bilozor } alt="Małgorzata Renigier-Biłozor" /></a>
                        <p><a href="https://uwm.edu.pl/igpig/kapirn/malgorzata-renigier-bilozor" target="_blank" rel="noreferrer"><b>Prof. dr hab. inż. Małgorzata Renigier-Biłozor</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>

                    <li>
                        <a className="committee-more" href="https://uwm.edu.pl/kgse/sklad-osobowy/andrzej-bilozor" target="_blank" rel="noreferrer"><img src={ andrzej_bilozor } alt="Andrzej Biłozor" /></a>
                        <p><a href="https://uwm.edu.pl/kgse/sklad-osobowy/andrzej-bilozor" target="_blank" rel="noreferrer"><b>Dr hab. inż. Andrzej Biłozor, prof. UWM</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>

                    <li>
                        <a className="committee-more" href="https://uwm.edu.pl/kgse/sklad-osobowy/iwona-cieslak" target="_blank" rel="noreferrer"><img src={ iwona_cieslak } alt="Iwona Cieślak" /></a>
                        <p><a href="https://uwm.edu.pl/kgse/sklad-osobowy/iwona-cieslak" target="_blank" rel="noreferrer"><b>Dr hab. inż. Iwona Cieślak, prof. UWM</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>

                    <li>
                        <a className="committee-more" href="https://bazawiedzy.uwm.edu.pl/info/author/UWM8092fe806ba84e548a8d36125b6eb440/" target="_blank" rel="noreferrer"><img src={ wioleta_blaszczak } alt="Wioleta Błaszczak-Bąk" /></a>
                        <p><a href="https://bazawiedzy.uwm.edu.pl/info/author/UWM8092fe806ba84e548a8d36125b6eb440/" target="_blank" rel="noreferrer"><b>Dr hab. inż. Wioleta Błaszczak-Bąk, prof. UWM</b></a><br />
                        Instytut Geodezji i&nbsp;Budownictwa<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>

                    <li>
                        <a className="committee-more" href="https://www.uni.lodz.pl/pracownicy/marta-nalej" target="_blank" rel="noreferrer"><img src={ marta_nalej } alt="Marta Nalej" /></a>
                        <p><a href="https://www.uni.lodz.pl/pracownicy/marta-nalej" target="_blank" rel="noreferrer"><b>Dr inż. Marta Nalej</b></a><br />
                        Instytut Geografii Miast, Turyzmu i&nbsp;Geoinformacji<br />
                        Wydział Nauk Geograficznych<br />
                        Uniwersytet Łódzki</p>
                    </li>

                    <li>
                        <a className="committee-more" href="https://uwm.edu.pl/kgse/sklad-osobowy/mateusz-ciski" target="_blank" rel="noreferrer"><img src={ mateusz_ciski } alt="Mateusz Ciski" /></a>
                        <p><a href="https://uwm.edu.pl/kgse/sklad-osobowy/mateusz-ciski" target="_blank" rel="noreferrer"><b>Dr inż. Mateusz Ciski</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>

                    <li>
                        <a className="committee-more" href="https://uwm.edu.pl/kgse/sklad-osobowy/bartlomiej-ezlakowski" target="_blank" rel="noreferrer"><img src={ bartlomiej_ezlakowski } alt="Magdalena Bigoszewska" /></a>
                        <p><a href="https://uwm.edu.pl/kgse/sklad-osobowy/bartlomiej-ezlakowski" target="_blank" rel="noreferrer"><b>Mgr inż. Bartłomiej Eźlakowski</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>

                    <li>
                        <a className="committee-more" href="https://uwm.edu.pl/kgse/sklad-osobowy/magdalena-bigoszewska" target="_blank" rel="noreferrer"><img src={ blank_person } alt="Magdalena Bigoszewska" /></a>
                        <p><a href="https://uwm.edu.pl/kgse/sklad-osobowy/magdalena-bigoszewska" target="_blank" rel="noreferrer"><b>Lic. Magdalena Bigoszewska</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>


                    <h3>Multimedia</h3>
                    <li>
                        <a className="committee-more" href="https://orcid.org/0009-0006-5922-3593" target="_blank" rel="noreferrer"><img src={ blank_person } alt="Paweł Majorowski" /></a>
                        <p><a href="https://orcid.org/0009-0006-5922-3593" target="_blank" rel="noreferrer"><b>Mgr inż. Paweł Majorowski</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>

                    <li>
                        <a className="committee-more" href="" target="_blank" rel="noreferrer"><img src={ blank_person } alt="Jakub Jurewicz" /></a>
                        <p><a href="" target="_blank" rel="noreferrer"><b>Mgr inż. Jakub Jurewicz</b></a><br />
                        Instytut Gospodarki Przestrzennej i&nbsp;Geografii<br />
                        Wydział Geoinżynierii<br />
                        Uniwersytet Warmińsko-Mazurski w&nbsp;Olsztynie</p>
                    </li>
                </ul>
            </div>
        </div> 
    </div>
  )
}

export default Committees